module.exports = __webpack_public_path__ + "img/elevator_big_open.614c65f2.png";